import { isBinaryContentType } from '@mockd/shared/utils';
import { ROUTES } from '../../routes';

const TEXT_RESPONSES_DOCS = `${ROUTES.docs()}/basics/endpoints/#text-responses-only`;

/**
 * Warns that a binary content type can't be served: bodies are sent as UTF-8
 * text, so a pasted PDF or image reaches the caller corrupted. Warns rather
 * than blocks, since an all-ASCII body of that type does come through intact.
 */
export function BinaryContentTypeHint({ contentType }: { contentType: string }) {
  if (!isBinaryContentType(contentType)) return null;

  return (
    <p className="label whitespace-normal text-warning">
      <span>
        Response bodies are sent as UTF-8 text, so binary files like PDFs or images can't be returned.{' '}
        {/* A new tab: navigating away would unmount the form and lose its edits. */}
        <a href={TEXT_RESPONSES_DOCS} target="_blank" rel="noopener noreferrer" className="link">
          Learn more <span className="sr-only">(opens in a new tab)</span>
        </a>
      </span>
    </p>
  );
}
